import * as React from 'react'
import * as cn from 'classnames'
import * as cardStyles from '../Card.module.scss'
import * as styles from './PlayButtonContainer.module.scss'
import PlayButton from './PlayButton'
import checkUrlType from '../../../../../utils/url-type-checker'
import { StorefrontItemPlaybackAction } from 'DVWebNodeUtils'
import { PlayerContext } from '@shared/player/integration/playbackArea'

interface PlayButtonContainerProps {
  style?: React.CSSProperties
  playbackAction: StorefrontItemPlaybackAction
  onClick: Function
  linkRef: React.RefObject<HTMLAnchorElement>
  canLivePlayback: boolean
  isLive: boolean
  shouldFadeIn?: boolean
  children?: React.ReactChild | React.ReactChild[]
  playButtonClassName?: string
}

const PlayButtonContainer = (props: PlayButtonContainerProps) => (
  <PlayerContext.Consumer>
    {({ onPlay }) => {
      const href = checkUrlType(
        props.playbackAction &&
          (!props.isLive || props.canLivePlayback) &&
          props.playbackAction.fallbackUrl,
        'PlayButtonContainer'
      )
      const fallbackUrl =
        props.playbackAction && props.playbackAction.appFallbackUrl
      const videoType =
        props.playbackAction && props.playbackAction.videoMaterialType
      const asin = props.playbackAction && props.playbackAction.titleID
      const lcid = props.playbackAction && props.playbackAction.channelId
      const refTag = props.playbackAction && props.playbackAction.refMarker
      const resumeTime =
        props.playbackAction && (props.playbackAction.resumeTime || 0)
      const onClick = onPlay
        ? (e: React.MouseEvent) => {
            onPlay({
              playbackUrl: href,
              fallbackUrl,
              contentConfig: {
                asin,
                lcid,
                videoType,
                ref: refTag,
                trailer: videoType === 'Trailer',
                position: resumeTime,
              },
            })
            e.preventDefault()
          }
        : () => {
            // TODO(AVWebStorefront-2952): This is most likely legacy code that should be removed
            if (props.onClick) {
              props.onClick()
            }
          }

      return (
        <div
          style={props.style}
          className={cn(
            {
              deeplinkable: Boolean(props.playbackAction && !onPlay),
            },
            cardStyles.PlayButtonContainer,
            props.playButtonClassName
          )}>
          <a
            ref={props.linkRef}
            onClick={onClick}
            data-lcid={lcid}
            data-asin={asin}
            data-ref-tag={refTag}
            data-ref={props.playbackAction && props.playbackAction.refMarker}
            data-resume-time={resumeTime}
            href={href}
            data-video-type={videoType}
            data-session-id={
              props.playbackAction && props.playbackAction.sessionID
            }
            data-fallback-url={fallbackUrl}>
            {props.children}
            <div
              className={cn('tst-playbutton', [styles.PlayButtonActionArea], {
                [styles.live]: props.isLive,
              })}>
              <PlayButton
                wrapperStyle={styles.playButton}
                svgStyle={styles.svg}
                circleStyle={styles.circle}
                triangleStyle={styles.triangle}
              />
            </div>
          </a>
        </div>
      )
    }}
  </PlayerContext.Consumer>
)

export default PlayButtonContainer
